import { render, staticRenderFns } from "./comTerm2.vue?vue&type=template&id=5db22f94&scoped=true&"
import script from "./comTerm2.vue?vue&type=script&lang=js&"
export * from "./comTerm2.vue?vue&type=script&lang=js&"
import style0 from "./comTerm2.vue?vue&type=style&index=0&id=5db22f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db22f94",
  null
  
)

export default component.exports